import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  events: []
};

const slice = createSlice({
  name: 'eventBillboard',
  initialState,
  reducers: {
    setEventBillboard: (state, { payload }) => ({
      ...state,
      events: payload,
    }),
    restore: () => initialState,
  },
});

export const {
  restore,
  setEventBillboard
} = slice.actions;

export default slice.reducer;
